import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Automation\DuplicateAutomationController::__invoke
* @see app/Http/Controllers/Automation/DuplicateAutomationController.php
* @route '/api/automation/{automation}/duplicate'
*/
const DuplicateAutomationController = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: DuplicateAutomationController.url(args, options),
    method: 'put',
})

DuplicateAutomationController.definition = {
    methods: ["put"],
    url: '/api/automation/{automation}/duplicate',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Automation\DuplicateAutomationController::__invoke
* @see app/Http/Controllers/Automation/DuplicateAutomationController.php
* @route '/api/automation/{automation}/duplicate'
*/
DuplicateAutomationController.url = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { automation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.id
        : args.automation,
    }

    return DuplicateAutomationController.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Automation\DuplicateAutomationController::__invoke
* @see app/Http/Controllers/Automation/DuplicateAutomationController.php
* @route '/api/automation/{automation}/duplicate'
*/
DuplicateAutomationController.put = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: DuplicateAutomationController.url(args, options),
    method: 'put',
})

export default DuplicateAutomationController